import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from 'react';

type MenuDrawerContextValue = {
  isOpen: boolean;
  openMenuDrawer: () => void;
  closeMenuDrawer: () => void;
};

const MenuDrawerContext = createContext<MenuDrawerContextValue | null>(null);

export function MenuDrawerProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);

  const openMenuDrawer = useCallback(() => setIsOpen(true), []);
  const closeMenuDrawer = useCallback(() => setIsOpen(false), []);

  const value = useMemo(
    () => ({ isOpen, openMenuDrawer, closeMenuDrawer }),
    [isOpen, openMenuDrawer, closeMenuDrawer],
  );

  return (
    <MenuDrawerContext.Provider value={value}>
      {children}
    </MenuDrawerContext.Provider>
  );
}

export function useMenuDrawer(): MenuDrawerContextValue {
  const ctx = useContext(MenuDrawerContext);
  if (!ctx) {
    return {
      isOpen: false,
      openMenuDrawer: () => undefined,
      closeMenuDrawer: () => undefined,
    };
  }
  return ctx;
}
